import { render, staticRenderFns } from "./input3.vue?vue&type=template&id=f4a4d146&scoped=true&"
import script from "./input3.vue?vue&type=script&lang=js&"
export * from "./input3.vue?vue&type=script&lang=js&"
import style0 from "./input3.vue?vue&type=style&index=0&id=f4a4d146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a4d146",
  null
  
)

export default component.exports